module.exports = __webpack_public_path__ + "img/icon-menu-meat.90e8deed.svg";